import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'
import { Boxes, Package, Receipt } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'vnetwork-ui'
import ProductGroupsTab from './ProductGroupsTab'
import ProductsTab from './ProductsTab'
import VatRatesTab from './VatRatesTab'

const ProductServiceManagement: React.FC = () => {
    const { t } = useTranslation('settings')

    const { TabProps, TabComponent } = useTabs({
        tabs: [
            {
                label: t('product-groups'),
                value: 'product-groups',
                startIcon: <Boxes className="h-4 w-4" />,
                component: <ProductGroupsTab />,
            },
            {
                label: t('products'),
                value: 'products',
                startIcon: <Package className="h-4 w-4" />,
                component: <ProductsTab />,
            },
            {
                label: t('vat-rates'),
                value: 'vat',
                startIcon: <Receipt className="h-4 w-4" />,
                component: <VatRatesTab />,
            },
        ],
    })

    return (
        <div className="space-y-2">
            <SubHeaders
                breadcrumbs={[
                    { path: paths.settings, title: t('settings') },
                    {
                        path: paths.productServiceManagement,
                        title: t('product-service-management'),
                    },
                ]}
            />

            <Tabs {...TabProps} />
            {TabComponent}
        </div>
    )
}

export default ProductServiceManagement
